import { render, staticRenderFns } from "./aShop.vue?vue&type=template&id=a3250c22&scoped=true"
import script from "./aShop.vue?vue&type=script&lang=js"
export * from "./aShop.vue?vue&type=script&lang=js"
import style0 from "./aShop.vue?vue&type=style&index=0&id=a3250c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3250c22",
  null
  
)

export default component.exports